import "./Projects.css";
import cj from "./cj.jpg";
import benny from "./benny.jpeg";
import behold from "./behold.jpeg";
import forcedhand from "./forced-hand.jpg";
import atlas from "./atlas-at-hold.jpg";
import ghosts from "./always-chasing-ghosts.jpg";
import tazmel from "./tazmel.jpg";
import badToWorse from "./bad-to-worse.jpg";
import twistWrithe from "./twist-writhe.jpg";
import majaHiness from "./maja-hiness.jpg";
import jessBoyer from "./jess-boyer.jpg";
import mikahlLawless from "./mikahl-lawless.jpg";

function Projects() {

    return (
        <>
        <ul className="project__list">
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Tall Grass</span>
                        <span className="project__artist">Forced Hand</span>
                        <span className="project__genre">Metal</span>
                        <span className="project__credits">recording, mixing and mastering</span>
                        <a href="https://open.spotify.com/track/4IAVMuViCddIvUIdBM1PR2?si=3f5261310a9249df" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={forcedhand} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Deadweight</span>
                        <span className="project__artist">Atlas At Hold</span>
                        <span className="project__genre">Metal</span>
                        <span className="project__credits">recording, mixing and mastering</span>
                        <a href="https://open.spotify.com/track/0Rv4k4bZgON0F0WKv3Ajj1?si=7854d92b5bef4bf2" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={atlas} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">I Am Not Okay</span>
                        <span className="project__artist">Benny Bugz</span>
                        <span className="project__genre">Rap</span>
                        <span className="project__credits">mix, master and produce</span>
                        <a href="https://open.spotify.com/track/706HhC23xP0sW6JmgmTgCi?si=120134ed33724938" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={benny} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Behold</span>
                        <span className="project__artist">See Through You</span>
                        <span className="project__genre">Metal</span>
                        <span className="project__credits">mix and master</span>
                        <a href="https://open.spotify.com/track/7yxANPBFaAx7b55vMRPVMD?si=d79d088c50cb4793" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={behold} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Down to My Soul</span>
                        <span className="project__artist">CJ Wood</span>
                        <span className="project__genre">Rock</span>
                        <span className="project__credits">mix, master and produce</span>
                        <a href="https://open.spotify.com/track/7MKVtSPBqPoJNxN8931u1T?si=c06f5cddda414f1b" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={cj} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Septa Bus</span>
                        <span className="project__artist">Tazmel</span>
                        <span className="project__genre">Singer-songwriter</span>
                        <span className="project__credits">recording, mixing and mastering</span>
                        <a href="https://open.spotify.com/track/1rGDn89PbrC2jeammVKlwS?si=3f5ae297ebb545bc" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={tazmel} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Bikes</span>
                        <span className="project__artist">Bad to Worse</span>
                        <span className="project__genre">Punk</span>
                        <span className="project__credits">recording, mixing and mastering</span>
                        <a href="https://open.spotify.com/track/5OrLY50pBpLZBcbFZyJh7m?si=cbf47877a9f3412b" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={badToWorse} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Crazy/Beautiful</span>
                        <span className="project__artist">Always Chasing Ghosts</span>
                        <span className="project__genre">Metal</span>
                        <span className="project__credits">recording, mixing and mastering</span>
                        <a href="https://open.spotify.com/album/4YURdcZLArs9ysM1hUXd8G?si=UxbRHVf5QhG-PO8MoN8b0Q" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={ghosts} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Cover Me</span>
                        <span className="project__artist">Twist &amp; Writhe</span>
                        <span className="project__genre">Rock/Powerpop</span>
                        <span className="project__credits">recording, mixing and mastering</span>
                        <a href="https://open.spotify.com/track/4dKhOMknz1ThAwgZL49Ecq?si=ffb4aec3806c4e29" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={twistWrithe} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Hit the Deck</span>
                        <span className="project__artist">Mikahl Lawless</span>
                        <span className="project__genre">Rap</span>
                        <span className="project__credits">mix, master and produce</span>
                        <a href="https://open.spotify.com/track/5CcjECxagNPKoIBEXhWBsK?si=1c8dfa87146b4c56" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={mikahlLawless} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Scars</span>
                        <span className="project__artist">Maja Hiness</span>
                        <span className="project__genre">Rap</span>
                        <span className="project__credits">recording, mixing and mastering</span>
                        <a href="https://open.spotify.com/track/1e2oiGGLYWSYItnSn7Qaoh?si=1810cbd9e9564424" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={majaHiness} alt=''/>
                    </div>
                </div>
            </li>
            <li className="project__item fade-in-intersection">
                <div className="project__inner">
                    <div className="project__meta">
                        <span className="project__title">Medicine</span>
                        <span className="project__artist">Jess Boyer</span>
                        <span className="project__genre">Singer-songwriter</span>
                        <span className="project__credits">recording, mixing and mastering</span>
                        <a href="https://open.spotify.com/track/7jdVqHDjnnpgl4LVxaUGJG?si=7b2253cb7f80487c" className="project__link" target='_blank' rel='noreferrer'>Listen on Spotify</a>
                    </div>
                    <div className="project__body">
                        <img src={jessBoyer} alt=''/>
                    </div>
                </div>
            </li>
        </ul>
        </>
    )
}

export default Projects;